import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios'
import Chart from "react-apexcharts";
import * as _ from 'lodash-joins'
import MS from '../../../../commons/services/Moment'
import CS from '../../../../commons/services/Common'
import PS from './../../../PlantList/MonitoringApiService'
import { useTranslation } from 'react-i18next';

export default function Graph(props) {
    const [data, setData] = React.useState ([]);
    const [series1, setSeries1] = React.useState ([]);
    const [options1, setOptions1] = React.useState ({});
    const [series2, setSeries2] = React.useState ([]);
    const [options2, setOptions2] = React.useState ({});
    const [series3, setSeries3] = React.useState ([]);
    const [options3, setOptions3] = React.useState ({});
  const { t } = useTranslation();

    /*
    useInterval(() => { 
        let s = (new Date()).getSeconds();
        if (s === 0)
            callData(props.data);
    }, 1000);
    */

    useEffect(() => {
        const fetchData = async () => {
            callData(props.data);
        };
        fetchData();
    }, [props.data]);
    

    async function callData(data) {
        const d = CS.cloneObj(data).reverse();
        const categories = []; const power = [];
        const pvPower = []; const pvVolt = []; const pvCurrent = [];
        const rVolt = []; const sVolt = []; const tVolt = [];
        const rCurrent = []; const sCurrent = []; const tCurrent = [];
        d.some(v => {
            categories.push(v.time);
            power.push(v.power);
            pvPower.push(PS.formatNumber((v.pvCurrent * v.pvVolt) / 1000));
            pvVolt.push(v.pvVolt);
            pvCurrent.push(v.pvCurrent);
            rVolt.push(v.lineRVolt);
            sVolt.push(v.lineSVolt);
            tVolt.push(v.lineTVolt);
            rCurrent.push(v.lineRCurrent);
            sCurrent.push(v.lineSCurrent);
            tCurrent.push(v.lineTCurrent);
        })

        const serires1 = [
            { name:"DC", data: pvVolt },
            { name:"R", data: rVolt },
            { name:"S", data: sVolt },
            { name:"T", data: tVolt },
        ]
        

        setSeries1(serires1);
        setOptions1(
            {
                chart: {
                    id: 'chart3',
                    height: 350,
                    type: 'line',
                    animations: {
                        enabled: false,
                        /*
                        easing: 'linear',
                        dynamicAnimation: {
                            speed: 1000
                        },
                        animateGradually: {
                            enabled: true,
                            //delay: 150
                        },
                        */
                    },
                    toolbar: {
                        show: true
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: t('key389'),
                    align: 'left'
                },
                grid: {
                    show: true,
                    borderColor: '#e7e7e7',
                    row: {
                        //colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 0
                },
                xaxis: {
                    categories: categories,
                    /*
                    title: {
                        text: 'Time'
                    },
                    */
                    tickAmount: 24,
                    labels: {
                        //show: false,
                        formatter: function(value) {
                            return  MS.format(value, "HH:mm");
                        },
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM \'yy',
                            day: 'dd MMM',
                            hour: 'HH:mm'
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'Volt(V)'
                    },
                    labels: {
                        formatter: function(value) {
                            return CS.setComma(value.toFixed(0));
                        }
                    }
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: 0,
                    offsetX: 0
                }
            }
        );

        const serires2 = [
            { name:"DC", data: pvCurrent },
            { name:"R", data: rCurrent },
            { name:"S", data: sCurrent },
            { name:"T", data: tCurrent },
        ]
        setSeries2(serires2);
        setOptions2(
            {
                chart: {
                    id: 'chart3',
                    height: 350,
                    type: 'line',
                    animations: {
                        enabled: false,
                        /*
                        easing: 'linear',
                        animateGradually: {
                            enabled: true,
                            //delay: 150
                        },
                        */
                    },
                    toolbar: {
                        show: true
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: t('key390'),
                    align: 'left'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        //colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                },
                },
                markers: {
                    size: 0
                },
                xaxis: {
                    categories: categories,
                    tickAmount: 24,
                    labels: {
                        //show: false,
                        formatter: function(value) {
                            return  MS.format(value, "HH:mm");
                        },
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM \'yy',
                            day: 'dd MMM',
                            hour: 'HH:mm'
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: t('key391')
                    },
                    labels: {
                        formatter: function(value) {
                            return CS.setComma(value.toFixed(0));
                        }
                    }
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: 0,
                    offsetX: 0
                }
            }
        );

        const serires3 = [
            { name:"DC", data: pvPower },
            { name:"현재", data: power },
        ];
        setSeries3(serires3);
        setOptions3(
            {
                chart: {
                    id: 'chart3',
                    height: 350,
                    type: 'line',
                    animations: {
                        enabled: false,
                        /*
                        easing: 'linear',
                        animateGradually: {
                            enabled: true,
                            //delay: 150
                        },
                        */
                    },
                    toolbar: {
                        show: true
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: t('key392'),
                    align: 'left'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        //colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                },
                },
                markers: {
                    size: 0
                },
                xaxis: {
                    categories: categories,
                    tickAmount: 24,
                    labels: {
                        //show: false,
                        formatter: function(value) {
                            return  MS.format(value, "HH:mm");
                        },
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM \'yy',
                            day: 'dd MMM',
                            hour: 'HH:mm'
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: t('key393')
                    },
                    labels: {
                        formatter: function(value) {
                            return CS.setComma(value.toFixed(0));
                        }
                    }
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: 0,
                    offsetX: 0
                }
            }
        );
    }

    return (
        <>
            <Chart options={options1} series={series1} type="line" height={350} />
            <Chart options={options2} series={series2} type="line" height={350} />
            <Chart options={options3} series={series3} type="line" height={350} />
        </>
    );
}


function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    useEffect(() => {
      savedCallback.current = callback;
    });
  
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
  
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }, [delay]);
}